/**
 * E06-F05-T07 — row → score-explanation adapters (DOM-free).
 *
 * The arithmetic and the wording live ONCE, in `@eer/shared`
 * (`buildScoreExplanation`), so the AI-check screen and the Review table can never
 * explain the same percentage differently. These thin adapters only map the two row
 * DTOs onto the builder's input.
 *
 * Weights: the builder defaults to `DEFAULT_WEIGHTS`, which is what the live scorer
 * actually used — `researchAiChainWorker` calls `scoreCandidate` WITHOUT a weights
 * argument, so the stored score is a default-profile score. If the scorer ever starts
 * honouring the per-request `weight_profile` snapshot, that profile has to reach these
 * adapters too (see the debt note in docs/dev/api.md), or the breakdown would stop
 * adding up to the number on screen.
 */
import {
  buildScoreExplanation,
  type PipelineRow,
  type ReviewRow,
  type ScoreExplanation,
} from '@eer/shared';

/** Explanation for a row of the AI-check screen (pipeline DTO). */
export function pipelineRowExplanation(row: PipelineRow): ScoreExplanation {
  return buildScoreExplanation({
    score: row.score,
    grade: row.grade,
    breakdown: row.breakdown,
    evidence: row.evidence,
    aiStatus: row.aiStatus,
    stage: row.stage,
    needsHuman: row.needsHuman,
    rationale: row.rationale,
  });
}

/** Explanation for a row of the Review table (review DTO). */
export function reviewRowExplanation(row: ReviewRow): ScoreExplanation {
  return buildScoreExplanation({
    score: row.score,
    grade: row.grade,
    breakdown: row.breakdown,
    evidence: row.evidence,
    isManual: row.isManual,
    needsHuman: row.needsHuman,
    rationale: row.rationale,
  });
}
